import {
  createFileRoute,
  useNavigate,
  useSearch,
} from '@tanstack/react-router';
import { useEffect } from 'react';
import { z } from 'zod';

const searchSchema = z.object({
  id: z.coerce.string().optional(),
});

export const Route = createFileRoute(
  '/dashboard/product/add-product/sale-settings/'
)({
  validateSearch: searchSchema,
  component: SaleSettingsPage,
});

function SaleSettingsPage() {
  const navigate = useNavigate();
  const { id: productId } = useSearch({
    from: '/dashboard/product/add-product/sale-settings/',
  });

  useEffect(() => {
    navigate({
      to: '/dashboard/product/add-product',
      search: { id: productId, step: 'sale' },
      replace: true,
    });
  }, [productId, navigate]);

  return null;
}
